export const nullString = '–';
export type NullString = typeof nullString;
